import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col px-5 py-4 gap-3 rounded-xl bg-gray-100" }
const _hoisted_2 = {
  key: 0,
  class: "text-gray-900 text-sm font-medium"
}
const _hoisted_3 = {
  key: 1,
  class: "text-gray-500 text-xs"
}

import GgmsProgressBar from "@/components/GgmsProgressBar.vue"

interface Props {
    jobTitle?: string
    jobDescription?: string
    jobProgress: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'JobItem',
  props: {
    jobTitle: {},
    jobDescription: {},
    jobProgress: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.jobTitle)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.jobTitle), 1))
      : _createCommentVNode("", true),
    (_ctx.jobDescription)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.jobDescription), 1))
      : _createCommentVNode("", true),
    _createVNode(GgmsProgressBar, {
      isProgressNumberVisible: true,
      progress: _ctx.jobProgress,
      barColor: "bg-primary-color-500",
      progressSuffix: "%"
    }, null, 8, ["progress"])
  ]))
}
}

})